import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetGTipListPagingAndFilterRequest } from '../models/request/gTip/GetGTipListPagingAndFilterRequest';

export class GTipService {
    static async getGTipList(_skip: number | undefined, _take: number | undefined, _searchTerm: string | undefined) {
        try {
            var inputObj = {
                skip: _skip,
                take: _take,
                searchTerm: _searchTerm
            };

            console.log('SERVICE CALL - getGTipList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GTip/getGTipList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportGTipList(inputObj: GetGTipListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportGTipList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GTip/exportGTipList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getGTipListPagingAndFilter(inputObj: GetGTipListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetGTipListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GTip/GetGTipListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addGTip(_gTipId: string | undefined, _name: string | undefined, _openingBalance: string | undefined, _currencyTypeId: string | undefined, _accountingCode: string | undefined, _openingBalanceDate: string | undefined, _isCustomActive: number) {
        try {

            var inputObj = {
                gTipId: _gTipId,
                name: _name,
                openingBalance: _openingBalance,
                currencyTypeId: _currencyTypeId,
                accountingCode: _accountingCode,
                openingBalanceDate: _openingBalanceDate,
                isCustomActive: _isCustomActive,
            }

            console.log('SERVICE CALL - AddGTip', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GTip/AddGTip', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteGTip(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteGTip', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GTip/deleteGTip', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getGTipById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getGTipById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GTip/getGTipById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}